'use client';

import {
	getApp, getApps, initializeApp,
} from 'firebase/app';

import { FirebaseConfig } from '@/configs/firebase.config';

export const app = getApps().length === 0 ? initializeApp(FirebaseConfig) : getApp();
